export default function Logo({ size = "md", showText = true, textColor = "text-slate-900" }) {
  const sizes = {
    xs: "w-7 h-7",
    sm: "w-9 h-9",
    md: "w-10 h-10",
    lg: "w-12 h-12",
    xl: "w-16 h-16",
  };

  const textSizes = {
    xs: "text-base",
    sm: "text-lg",
    md: "text-xl",
    lg: "text-2xl",
    xl: "text-3xl",
  };

  return (
    <span className="flex items-center gap-2.5" data-testid="pickngo-logo">
      <img
        src="/pickngo-logo.jpeg"
        alt="PickNGo Swift"
        className={`${sizes[size]} rounded-xl object-contain bg-white`}
      />
      {showText && (
        <span className={`font-['Outfit'] ${textSizes[size]} font-extrabold tracking-tight`}>
          <span className={textColor}>Pick</span>
          <span className="text-[#FF6B00]">N</span>
          <span className={textColor}>Go</span>
          <span className={`${textColor} font-bold ml-1 opacity-80`}>Swift</span>
        </span>
      )}
    </span>
  );
}
